var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCircleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#06162D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 49.9369V49.9368V49.83C73.8849 35.7885 64.1515 26 50.6673 26C36.5158 25.9787 26 35.7244 26 50.001C26 64.2776 36.4238 73.9805 51.1045 73.9805C58.6787 74.2533 66.0466 71.6533 71.5149 66.7781L67.3269 61.948C63.0636 65.6661 57.4359 67.737 51.5877 67.7398C47.1041 67.9191 42.7288 66.429 39.4327 63.6003C36.1365 60.7715 34.1921 56.838 34.0307 52.6725H73.8389C74 51.839 74 50.8559 74 49.9369ZM34.132 46.6884H34.1222V46.7525C34.1254 46.7311 34.1287 46.7098 34.132 46.6884ZM34.132 46.6884H66.0148C65.0254 38.0754 58.9736 32.5828 50.5057 32.5828C41.3251 32.5828 35.4182 38.3875 34.132 46.6884Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLogo);
export default __webpack_public_path__ + "static/media/circle-logo.8e57eead4de0dc761e61802dfb8149a7.svg";
export { ForwardRef as ReactComponent };